import { AppState } from "./model";
import { immunisationSelector } from "./selectors";

export const routes = {
    "/immunisations": {
        title: "Immunisations",
        "/create": {
            title: "Create Immunisation",
        },
        "/immunisationRecord": {
            title: "Immunisation Record",
        },
        "/:immunisationId": {
            title: (state: AppState) => immunisationSelector(state) ? immunisationSelector(state).immunisationType.name : "Immunisation",
            "/edit": {
                title: "Edit"
            }
        },
        "/createImmunisationCase": {
            title: "Create Immunisation Case"
        }
    }
};
